const profileSettings = {
  title: '账号设置',
  subtitle: '维护你的招聘资料、账号绑定与订阅状态。',
  navigationLabel: '账号设置导航',
  profileCardTitle: '个人资料',
  profileCardDesc: '这些信息会用于你的招聘协作与账号识别，请保持最新。',
  accountCardTitle: '账号与登录',
  accountCardDesc: '查看当前登录账号，并管理密码与登录方式。',
  socialCardTitle: '已连接账号',
  socialCardDesc: '绑定社交账号后，可直接用于登录和部分招聘功能。',
  preferencesCardTitle: '偏好设置',
  preferencesCardDesc: '统一管理语言切换和官网用户中心入口。',
  pointsCardTitle: '用户积分',
  pointsCardDesc: '查看当前账户剩余的联系积分和 AI积分。',
  planCardTitle: '套餐与订阅',
  planCardDesc: '查看当前会员状态与自动续费信息。',
  fields: {
    hiringCompany: '当前公司名称',
    identity: '身份',
    name: '姓名',
    title: 'Title',
    linkedinAccountType: '当前 LinkedIn 账号类型',
    contact: '联系方式',
    email: '登录邮箱',
    password: '账号密码',
    language: '界面语言',
    userCenter: '用户中心',
  },
  placeholders: {
    hiringCompany: '请输入当前公司名称',
    name: '请输入姓名',
    title: '请输入 Title',
    linkedinAccountType: '请选择 LinkedIn 账号类型',
    contact: '例如 wechat: xxx / email: xxx',
  },
  identityOptions: {
    hr: 'HR',
    headhunter: '猎头',
  },
  linkedinAccountTypes: {
    business: 'Business',
    sales: 'Sales',
    recruiter: 'Recruiter',
    personal: 'Personal',
  },
  sections: {
    work: '工作信息',
    workDesc: '用于识别你当前所在的招聘团队。',
    identity: '个人身份',
    identityDesc: '告诉我们如何称呼你，以及你的招聘角色。',
    recruiting: '招聘账号',
    recruitingDesc: '补充 LinkedIn 使用场景和可联系信息。',
  },
  actions: {
    save: '保存资料',
    edit: '编辑资料',
    complete: '去完善',
    cancel: '取消',
    retry: '重新加载',
    changePassword: '修改密码',
    manageBilling: '前往套餐页',
    openUserCenter: '打开用户中心',
  },
  languages: {
    zhCN: '简体中文',
    en: 'English',
  },
  userCenter: {
    title: '官网用户中心',
  },
  empty: {
    title: '请完善个人资料',
    desc: '补充公司、姓名和 LinkedIn 账号类型，帮助系统提供更准确的招聘体验。',
  },
  incomplete: {
    title: '资料待完善',
    desc: '还有必填信息未填写，完善后即可正常使用完整招聘能力。',
  },
  loadError: {
    title: '个人资料加载失败',
    desc: '暂时无法读取个人资料，请重新加载后再编辑。',
  },
  status: {
    loading: '加载中...',
    notProvided: '未填写',
    linked: '已绑定',
    notLinked: '未绑定',
    freePlan: '免费版',
    passwordProtected: '已启用账号密码保护',
  },
}

export default profileSettings
